import React from "react";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import { PlusOutlined } from "@ant-design/icons";
import CollectionForm from "./CollectionForm";

function CollectionCreateComponent() {
    return (
        <QurealSection
            header={
                <SectionHeader
                    heading="Create New Collection"
                    icon={<PlusOutlined />}
                />
            }
        >
            <CollectionForm />
        </QurealSection>
    );
}

export default CollectionCreateComponent;
